import React from 'react';
import { TOKENS } from '../tokens.js';

export function Tape({ style, variant = 'orange' }) {
  const cls = variant === 'orange' ? 'tape' : variant === 'maroon' ? 'tape maroon' : 'tape stone';
  return <div className={cls} style={style} />;
}

export function Stamp({ children, color = TOKENS.maroon, rotate = -4, style }) {
  return <span className="stamp" style={{ color, transform: `rotate(${rotate}deg)`, ...style }}>{children}</span>;
}

export function PhotoPlaceholder({ seed = 0, style }) {
  const palettes = [
    ['#861F41', '#E5751F'], ['#5C1229', '#75787B'], ['#E5751F', '#861F41'],
    ['#B75813', '#FBF8F2'], ['#6B1934', '#E5751F'], ['#75787B', '#861F41'],
  ];
  const [a, b] = palettes[seed % palettes.length];
  return (
    <div style={{
      width: '100%', aspectRatio: '1 / 1',
      background: `linear-gradient(135deg, ${a} 0%, ${b} 100%)`,
      display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
      position: 'relative', overflow: 'hidden', ...style,
    }}>
      <svg viewBox="0 0 100 100" style={{ position: 'absolute', bottom: 0, width: '72%', height: '90%', opacity: 0.22 }}>
        <circle cx="50" cy="32" r="18" fill="#000" />
        <path d="M14 100 C 14 68, 86 68, 86 100 Z" fill="#000" />
      </svg>
    </div>
  );
}

export function Sticker({ children, color = TOKENS.orange, size = 90, rotate = -8, style }) {
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%',
      background: color, color: TOKENS.ink,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      textAlign: 'center', padding: 10,
      fontFamily: 'Fraunces, serif', fontWeight: 900, lineHeight: 1,
      boxShadow: '0 2px 4px rgba(0,0,0,0.15), inset 0 0 0 3px rgba(255,255,255,0.25), inset 0 0 0 4px currentColor',
      transform: `rotate(${rotate}deg)`, ...style,
    }}>{children}</div>
  );
}

export function TicketDivider({ label, color = TOKENS.orangeDark }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: 'clamp(28px, 5vw, 44px) 0' }}>
      <div style={{ flex: 1, borderTop: `1.5px dashed ${color}`, opacity: 0.4 }} />
      <div className="hand" style={{ color, fontSize: 'clamp(22px, 4vw, 28px)', lineHeight: 1 }}>{label}</div>
      <div style={{ flex: 1, borderTop: `1.5px dashed ${color}`, opacity: 0.4 }} />
    </div>
  );
}

export function Ticker({ items }) {
  const row = items.map((t, i) => (
    <span key={i} style={{ opacity: i % 2 ? 0.5 : 1 }}>{t}</span>
  ));
  return (
    <div className="ticker">
      <div className="ticker-track">
        {row}{row}{row}{row}
      </div>
    </div>
  );
}
